interface IndexItem {
  icon: string;
  title: string;
  count: string;
  desc: string;
}

const indexItems: IndexItem[] = [
  {
    icon: 'ri-fire-fill',
    title: '今日热榜',
    count: '32条更新',
    desc: '当日最热门爆料动态汇总',
  },
  {
    icon: 'ri-movie-2-line',
    title: '娱乐圈',
    count: '156条爆料',
    desc: '明星八卦、影视圈内幕',
  },
  {
    icon: 'ri-live-line',
    title: '网红圈',
    count: '89条爆料',
    desc: '直播翻车、网红塌房实录',
  },
  {
    icon: 'ri-building-4-line',
    title: '社会热点',
    count: '203条爆料',
    desc: '公共事件、社会新闻解读',
  },
  {
    icon: 'ri-gamepad-line',
    title: '电竞圈',
    count: '67条爆料',
    desc: '电竞赛事、选手幕后故事',
  },
  {
    icon: 'ri-user-voice-line',
    title: '独家专访',
    count: '41条内容',
    desc: '一线当事人深度对话',
  },
  {
    icon: 'ri-image-line',
    title: '实锤图集',
    count: '118组图片',
    desc: '一手现场照片与截图证据',
  },
  {
    icon: 'ri-vidicon-line',
    title: '视频爆料',
    count: '74条视频',
    desc: '现场视频与录屏实况',
  },
  {
    icon: 'ri-file-list-3-line',
    title: '深度专题',
    count: '28期专题',
    desc: '多角度事件完整梳理',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1100px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            专题索引
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            按分类浏览你感兴趣的吃瓜内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#updates"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex flex-col items-center text-center p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/30 transition-all cursor-pointer"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-semibold text-foreground-900 text-sm md:text-base mb-1">
                {item.title}
              </h3>
              <span className="text-xs text-primary-600 font-medium mb-1.5">{item.count}</span>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}